/* src/app/umbrella-common/components/review-checklist-documents/review-checklist-documents.style.scss */
.header {
  display: flex;
  margin-top: 30px;
}
.header h6 {
  margin-top: 0;
  margin-bottom: 10px;
  margin-right: 20px;
  max-width: 299px;
  width: 299px;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  color: #007d40;
}
.documents {
  margin-bottom: 30px;
}
.documents .document {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  border-bottom: #e6e6e6 solid 1px;
  padding-bottom: 3px;
}
.documents .document .document-name {
  font-weight: bold;
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
.documents .document .created {
  margin-top: 3px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #585858;
}
.documents .document .document-link {
  cursor: pointer;
  margin-right: 20px;
  color: #007d40;
  width: 25px;
  height: 25px;
}
/*# sourceMappingURL=review-checklist-documents.style.css.map */
